import './Error404.scss';
import Component from './Error404.js';
import ReactiveWrapper from '../ReactiveWrapper';
export default ReactiveWrapper(Component);
